import get from 'lodash/get';
import keyBy from 'lodash/keyBy';
import fromPairs from 'lodash/fromPairs';
import cloneDeep from 'lodash/cloneDeep';
import findIndex from 'lodash/findIndex';
import filter from 'lodash/filter';
import {statistyChecked} from '~/misc/checked';

import resourceId from '~/misc/resourceId';
import {checked, checkedAll, confirmCheckedAll} from '~/misc/checked';
import A from './types';

const initialState = {};

const searchStatuses = {
  [A.SIMILAR_LOADS_FOUND]: 'loading',
  [A.SIMILAR_LOADS_SORTED]: 'sorting',
};

const getResourceIdentity = (query, parentIdentity) =>
  resourceId('similarLoads', {
    query: query,
  }, parentIdentity);

const getCountPairs = (item, i) => ([item.id, i]);

const getOrderIndex = (main, added) =>
  fromPairs([].concat(
    main.map(getCountPairs),
    added.map(getCountPairs)
  ));

const reducer = (state, action, fullState) => {
  switch (action.type) {
    case A.SIMILAR_LOADS_CRITERIA: {
      const data = action.payload;

      return {
        query: data,
        status: null,
        identity: getResourceIdentity(data, fullState.loadsSearch.identity),
      };
    }

    case A.SIMILAR_HIDE_THE_LOADS: {
      let shipments = cloneDeep(state.results.shipments);
      let total = state.total;
      let showCount = state.showCount;
      const results = state.results;
      for (let i = 0; i < action.payload.data.length; i++) {
        shipments = filter(shipments, item => item[action.payload.idType] !== action.payload.data[i]);
      }
      results.shipments = shipments;
      total -= action.payload.data.length;
      showCount -= action.payload.data.length;

      return Object.assign({}, state,
        {
          results,
          total,
          showCount,
          hasItems: Boolean(shipments.length),
        }
      );
    }
    case A.SIMILAR_HIDE_THE_COMPANY: {
      let shipments = cloneDeep(state.results.shipments);
      const oldListLength = shipments.length;
      let total = state.total;
      let showCount = state.showCount;
      const results = state.results;
      shipments = filter(shipments,
        item => item.company !== action.payload.data.company || item.broker_id !== action.payload.data.id
      );
      const newListLength = shipments.length;
      const difference = oldListLength - newListLength;
      results.shipments = shipments;
      total -= difference;
      showCount -= difference;

      return Object.assign({}, state,
        {
          results,
          total,
          showCount,
          hasItems: Boolean(shipments.length),
        }
      );
    }
    case A.COLLECTION_THE_COMPANY: {
      const results = cloneDeep(state.results);
      for (let i = 0; i < results.shipments.length; i++) {
        if (results.shipments[i].broker_id === action.payload.id
          || results.shipments[i].company === action.payload.company) {
          results.shipments[i].checkedBroker = true;
        }
      }
      return Object.assign({}, state, {results});
    }
    case A.NO_COLLECTION_COMPANY: {
      const results = cloneDeep(state.results);
      for (let i = 0; i < results.shipments.length; i++) {
        if (results.shipments[i].broker_id === action.payload.id
          || results.shipments[i].company === action.payload.company) {
          results.shipments[i].checkedBroker = false;
        }
      }
      return Object.assign({}, state, {results});
    }

    case A.SIMILAR_LOADS_FOUND:
    case A.SIMILAR_LOADS_SORTED: {
      if (action.error) {
        return {
          status: 'error',
        };
      }

      if (action.pending) {
        const status = searchStatuses[action.type];
        return {
          status: status,
          results: status === 'sorting' ? state.results : null,
          total: status === 'sorting' ? state.total : null,
        };
      }

      if (!action.payload) {
        return {
          status: 'ok',
          results: {
            shipments: [],
            total_shipments: 0,
          },
          noneResults: true,
          hasItems: false,
          itemsIndex: {},
          total: 0,
          showCount: 0,
          orderIndex: {},
        };
      }

      const count = action.payload && parseInt(action.payload.total_shipments, 10);
      const mainCount = get(fullState, 'loadsSearch.total', 0);


      const payloadList = (action.payload.shipments || []).map(item => ({
        ...item,
        identity: resourceId('loadsSearchItem', {
          id: item.id,
        }, state.identity),
        parentIdentity: state.identity,
      }));

      const checkedAll = confirmCheckedAll(payloadList);
      return {
        status: 'ok',
        results: {
          ...action.payload,
          shipments: payloadList,
        },
        noneResults: false,
        hasItems: Boolean(get(action, 'payload.shipments.length')),
        total: count - mainCount,
        showCount: payloadList.length,
        itemsIndex: keyBy(payloadList, 'id'),
        orderIndex: getOrderIndex(payloadList, []),
        checkedAll,
        checked: statistyChecked(payloadList),
      };
    }
    case A.SIMILAR_LOADS_CHECKED: {
      return checked(action.payload.id, state);
    }
    case A.SIMILAR_LOADS_CHECKED_ALL: {
      return checkedAll(state);
    }
    case A.CLEAR_SIMILAR_CHECKED: {
      return {
        checkedAll: false,
      };
    }
    case A.UPDATE_SIMILAR_CHECKED: {
      const fullList = state.results.shipments;
      return {
        checked: statistyChecked(fullList),
      };
    }
  }

  return null;
};

export default {reducer, initialState};



// WEBPACK FOOTER //
// ./src/modules/similarLoads/reducer.js